// @ts-nocheck
/*
 * Port of views/dashboard/voice-plan/voice-plan-shared.js (origin/main-dev, 162 lines).
 * BYTE-IDENTICAL — CallTypeIcon/CallTypeChip/PlanStatusBadge/LegTypeDisplay/
 * CallTypeMetricList and CALL_TYPE_META map preserved verbatim.
 */
import React from 'react';
import {
  FaPhoneAlt,
  FaPhoneVolume,
  FaPhoneSlash,
  FaHeadset,
  FaGlobe,
  FaRobot,
  FaMinusCircle,
} from 'react-icons/fa';
import { getLegTypeLabel } from '@/utilities/voicePlanUtils';

const CALL_TYPE_META = {
  INBOUND: { label: 'Inbound', className: 'vp-ct--inbound', Icon: FaPhoneAlt },
  OUTBOUND: { label: 'Outbound', className: 'vp-ct--outbound', Icon: FaPhoneVolume },
  MISSED: { label: 'Missed', className: 'vp-ct--missed', Icon: FaPhoneSlash },
};

export function CallTypeIcon({ type, size = 14 }) {
  const meta = CALL_TYPE_META[String(type || '').toUpperCase()];
  if (!meta) return null;
  const { Icon, className } = meta;
  return (
    <span className={`vp-ct-icon ${className}`}>
      <Icon size={size} />
    </span>
  );
}

export function CallTypeChip({ type }) {
  const meta = CALL_TYPE_META[String(type || '').toUpperCase()];
  if (!meta) return null;
  const { Icon, label, className } = meta;
  return (
    <span className={`vp-ct-chip ${className}`}>
      <Icon size={12} />
      {label}
    </span>
  );
}

export function PlanStatusBadge({ enabled, large }) {
  return (
    <span
      className={`vp-plan-status ${enabled ? 'vp-plan-status--on' : 'vp-plan-status--off'} ${
        large ? 'vp-plan-status--lg' : ''
      }`}
    >
      <span className="vp-plan-status__dot" />
      {enabled ? 'ENABLED' : 'DISABLED'}
    </span>
  );
}

export function LegTypeDisplay({ legType }) {
  if (!legType) {
    return (
      <span className="vp-leg-display">
        <span className="vp-leg-display__icon vp-leg-display__icon--na">
          <FaMinusCircle />
        </span>
        N/A
      </span>
    );
  }

  const value = String(legType).toUpperCase();
  if (value === 'CUSTOMER_PSTN') {
    return (
      <span className="vp-leg-display">
        <span className="vp-leg-display__icon vp-leg-display__icon--customer">
          <FaPhoneAlt />
        </span>
        Customer PSTN
      </span>
    );
  }
  if (value === 'AGENT_PSTN') {
    return (
      <span className="vp-leg-display">
        <span className="vp-leg-display__icon vp-leg-display__icon--agent">
          <FaHeadset />
        </span>
        Agent PSTN
      </span>
    );
  }
  if (value === 'AGENT_WEBRTC') {
    return (
      <span className="vp-leg-display">
        <span className="vp-leg-display__icon vp-leg-display__icon--webrtc">
          <FaGlobe />
        </span>
        Agent WebRTC
      </span>
    );
  }
  if (value === 'AI_AGENT') {
    return (
      <span className="vp-leg-display">
        <span className="vp-leg-display__icon vp-leg-display__icon--ai">
          <FaRobot />
        </span>
        AI Agent
      </span>
    );
  }

  return (
    <span className="vp-leg-display">
      <span className="vp-leg-display__icon vp-leg-display__icon--na">
        <FaMinusCircle />
      </span>
      {getLegTypeLabel(legType)}
    </span>
  );
}

export function CallTypeMetricList({ groups, field }) {
  if (!groups?.length) return <span className="vp-muted">—</span>;

  const labelMap = { INBOUND: 'Inbound', OUTBOUND: 'Outbound', MISSED: 'Missed' };

  return (
    <div className="vp-metric-list">
      {groups.map((group) => {
        const lines =
          group.type === 'MISSED'
            ? [
                {
                  key: 'missed',
                  value:
                    field === 'duration'
                      ? 'N/A'
                      : Number(group.legs[0]?.pulse_price ?? 0).toFixed(2),
                },
              ]
            : group.legs.map((leg, idx) => ({
                key: `${group.type}-${idx}`,
                value:
                  field === 'duration'
                    ? leg.pulse_duration
                      ? `${leg.pulse_duration === 1 ? '1' : leg.pulse_duration}s`
                      : 'N/A'
                    : Number(leg.pulse_price ?? 0).toFixed(2),
              }));

        return lines.map((line, lineIdx) => (
          <div className="vp-metric-list__row" key={line.key}>
            <CallTypeIcon type={group.type} size={13} />
            <span className="vp-metric-list__label">
              {labelMap[group.type]}
              {lines.length > 1 ? ` (${lineIdx + 1})` : ''}:
            </span>
            <span className="vp-metric-list__value">{line.value}</span>
          </div>
        ));
      })}
    </div>
  );
}
